import moment from "moment-timezone";

const common = {
  moment() {
    return moment().tz(process.env.VUE_APP_TIMEZONE);
  },
  momentTz() {
    return moment().tz(process.env.VUE_APP_TIMEZONE);
  },
  getNow() {
    return common.moment().format(process.env.VUE_APP_DATETIME_FORMAT);
  },
  getNowUTC() {
    return moment().utc();
  },

  getTimezone() {
    return process.env.VUE_APP_TIMEZONE;
  },
  // Returns true/false for a parseable datetime, or null when there is nothing
  // to judge. moment(undefined) silently returns NOW, which made a missing
  // value look like a datetime that has just expired -- so an unloaded session
  // reported itself as expired. null lets callers tell "unknown" from "valid".
  checkIsExpired(datetime) {
    if (datetime === null || datetime === undefined || datetime === "") {
      return null;
    }
    const expireTime = moment(datetime).utc();
    if (!expireTime.isValid()) {
      return null;
    }
    const currentTime = moment().utc();
    return expireTime.diff(currentTime, "seconds") <= 0;
  },
  formatDateTime(momentObject) {
    return momentObject.format(process.env.VUE_APP_DATETIME_FORMAT);
  },
  // NaN for anything unparseable, which is already what moment gives for null
  // or a malformed string; undefined now joins them instead of being read as
  // NOW. Callers (timer.js) already test isNaN, so this keeps that path intact.
  getDiffSecond(datetime) {
    if (datetime === null || datetime === undefined || datetime === "") {
      return NaN;
    }
    const expireTime = moment(datetime).utc();
    if (!expireTime.isValid()) {
      return NaN;
    }
    const currentTime = moment().utc();
    return expireTime.diff(currentTime, "seconds");
  },
};

export default common;
